export const stats = [
  { value: '+540', label: 'Gotowych Materiałów i Kart Pracy' },
  { value: '+1 500', label: 'Zadowolonych Nauczycieli' },
  { value: '3 800+', label: 'Zaoszczędzonych Godzin' },
  { value: '98%', label: 'Nauczycieli Nas Poleca' },
]

export const differenceStats = [
  { value: '+540', label: 'Ćwiczeń i Aktywności (Klasa 4 – Liceum)' },
  { value: '8', label: 'Pełnych Tomów Cyfrowych' },
  { value: '100%', label: 'Natychmiastowe Pobieranie' },
]

export const beforeItems = [
  'Godziny spędzone na planowaniu każdej lekcji od zera i szukaniu na 10 różnych stronach',
  'Doświadczenia, które się nie udają, bo brakuje materiałów lub jasnych instrukcji',
  'Brak wyraźnego połączenia między teorią a prawdziwym życiem',
  'Trudność w tworzeniu sprawdzianów dla różnych poziomów (SPE/dysleksja)',
  'Zniechęceni uczniowie, którzy uważają, że „biologia jest nudna”',
]

export const afterItems = [
  '5 minut na przejrzenie materiału i wchodzisz do klasy pewna siebie',
  'Praktyczne i angażujące doświadczenia z łatwo dostępnych materiałów',
  'Infografiki i mapy myśli wbudowane w każdy dział',
  'Quizy, sprawdziany, rozwiązania i rubryki gotowe w 100%',
  'Uczniowie, którzy obserwują, eksperymentują i naprawdę rozumieją',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Lęk przed tłumaczeniem: wchodzisz do klasy nie wiedząc, jak prosto wyjaśnić trudne pojęcia (jak fotosynteza czy podziały komórkowe)',
  },
  {
    emoji: '⏱️',
    text: 'Skradzione niedziele: spędzasz całą niedzielę na przygotowywaniu materiałów, które powinny zająć minuty',
  },
  {
    emoji: '🤷',
    text: 'Kreatywny chaos: masz problem ze znalezieniem kart pracy, które są nowoczesne, wizualne i wysokiej jakości',
  },
  {
    emoji: '📋',
    text: 'Nieskończone ocenianie: brak jasnych rubryk oceniania lub testów zgodnych z podstawą programową',
  },
  {
    emoji: '😴',
    text: 'Uczniowie zostający w tyle: materiał nie jest dostosowany do różnych potrzeb edukacyjnych (SPE/dysleksja)',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '8 Tomów opartych na roku szkolnym (Klasa 4 – Liceum)',
    text: 'Pełny program biologii: od przyrody, przez anatomię człowieka, aż po genetykę i metabolizm',
  },
  {
    emoji: '🧪',
    title: 'Zestawy Laboratoryjne i Doświadczenia',
    text: 'Karty techniczne do eksperymentów w klasie, z użyciem prostych materiałów i instrukcjami krok po kroku',
  },
  {
    emoji: '✏️',
    title: 'Skrypty lekcyjne «Gotowe od zaraz»',
    text: 'Wskazówki dydaktyczne, które mówią Ci dokładnie, co powiedzieć i jak poprowadzić lekcję',
  },
  {
    emoji: '📐',
    title: 'Biologia Wizualna: Infografiki i Mapy',
    text: 'Grafiki w wysokiej rozdzielczości, które czynią niewidoczne procesy zrozumiałymi dla każdego ucznia',
  },
  {
    emoji: '📊',
    title: 'Sprawdziany, Rozwiązania i SPE',
    text: 'Kompletne narzędzia oceny i ułatwione wersje dla inkluzywnej dydaktyki',
  },
  {
    emoji: '🔑',
    title: 'Klucze Odpowiedzi',
    text: 'Pełne rozwiązania każdego ćwiczenia dla błyskawicznego sprawdzania prac',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/kMNLDFdotHWixTzAjM5zje/Captura_de_pantalla_2026-09-09_a_la(s)_11.33.53_p.webp',
    level: 'Jednostka 2 · Ćwiczenia',
    title: 'Oznacz części rośliny',
    caption:
      'Karta gotowa do druku: opisywanie części rośliny, dopasowywanie ich do funkcji oraz bonusowy eksperyment „Roślina bez światła” krok po kroku.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5i61JWm2mz2RLPEMsyAyha/Captura_de_pantalla_2026-09-09_a_la(s)_11.36.01_p.webp',
    level: 'Jednostka 3 · Doświadczenie',
    title: 'Bakterie: dobre kontra złe',
    caption:
      'Scenariusz dla nauczyciela, sortowanie bakterii, mapa poszukiwań w domu i pełna procedura hodowli na szalce Petriego z zasadami bezpieczeństwa.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5VZ4beddmX5JMySdZDz9fJ/Captura_de_pantalla_2026-09-09_a_la(s)_11.36.44_p.webp',
    level: 'Jednostka 1 · Karta pracy',
    title: 'Anatomia rośliny',
    caption:
      'Trzy poziomy trudności: opisywanie części, łączenie z funkcją i przekrój poprzeczny liścia, plus eksperyment „Podróż wody w roślinie”.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3eParhAySPrj66szd4BKsX/Captura_de_pantalla_2026-09-09_a_la(s)_11.37.17_p.webp',
    level: 'Jednostka 1 · Ćwiczenie',
    title: 'Oznacz kości szkieletu',
    caption:
      'Pełna sylwetka szkieletu z ośmioma polami do opisania, gotowym kluczem odpowiedzi i eksperymentem „Gdzie jest Twój szkielet?”.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rN6pJ5VPbQa6XqfwRV7z7J/Captura_de_pantalla_2026-09-09_a_la(s)_11.38.12_p.webp',
    level: 'Jednostka 2 · Infografika',
    title: 'Zmysł słuchu — ucho i słyszenie',
    caption:
      'Przekrój ucha z opisem wszystkich struktur oraz schemat drogi dźwięku od fali akustycznej aż do mózgu.',
  },
]

export const bonuses = [
  {
    title: 'Plan Roczny',
    was: '120 PLN',
    text: 'Kompletny harmonogram, dzięki któremu zawsze zdążysz z realizacją podstawy programowej',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/950486b4-786a-4fec-b7ca-fc32030ef203.jpg',
  },
  {
    title: 'Szybki Start Nauczyciela',
    was: '90 PLN',
    text: 'Przewodnik wdrożeniowy, który pozwoli Ci zacząć korzystać z systemu w mniej niż 5 minut',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d3211a42-cea1-4320-b7aa-c3e8e8eea926.jpg',
  },
  {
    title: 'Bank Pytań Aktywujących',
    was: '100 PLN',
    text: 'Zestaw gotowych pytań na start lekcji, które natychmiast budzą ciekawość uczniów',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/2103cd85-8bf6-4bc0-a50b-0923f619c5c2.jpg',
  },
  {
    title: 'Zestaw Kart «Drukuj i Ucz»',
    was: '80 PLN',
    text: 'Błyskawiczne materiały na zastępstwa lub szybkie powtórki przed sprawdzianem',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0f699c53-11f4-4888-9534-54acf40eb37a.jpg',
  },
  {
    title: 'Pakiet Spokojnej Oceny',
    was: '90 PLN',
    text: 'Gotowe schematy oceniania i rubryki, które skrócą Twój czas sprawdzania prac o połowę',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/563acd4f-0b08-494c-98ef-319ab13ad95f.jpg',
  },
]

export const offerRows = [
  { label: 'BIOLOGIA GOTOWA™ Pack (8 Tomów Cyfrowych)', value: '290 PLN' },
  { label: '5 Bonusów Strategicznych', value: '480 PLN' },
]

export const testimonials = [
  {
    quote:
      'W końcu odzyskałam swoje wieczory. Doświadczenia są proste w wykonaniu, a dzieci je uwielbiają.',
    name: 'Katarzyna M.',
    location: 'Warszawa 🇵🇱',
  },
  {
    quote:
      'Mapy wizualne to zbawienie dla moich uczniów z dysleksją. Profesjonalny materiał gotowy do użycia.',
    name: 'Marek B.',
    location: 'Kraków 🇵🇱',
  },
  {
    quote:
      'Od podstawówki po liceum – to jedyna inwestycja, jakiej potrzebuje nauczyciel biologii.',
    name: 'Anna V.',
    location: 'Wrocław 🇵🇱',
  },
]

export const faqs = [
  {
    q: 'Jak otrzymam materiał?',
    a: 'Natychmiast po płatności otrzymasz link do pobrania plików PDF na swój e-mail.',
  },
  {
    q: 'Czy to subskrypcja?',
    a: 'Nie. Płacisz tylko raz i masz dostęp do wszystkich materiałów na zawsze.',
  },
  {
    q: 'Czy materiały są zgodne z polską podstawą programową?',
    a: 'Tak, wszystkie tomy zostały opracowane w oparciu o aktualne wymogi programowe w Polsce.',
  },
]
